const consultOrderMap = {
  // 生成询单记录
  saveInquiryExt: '/usb/uwb-app/api/v1/source/saveInquiry',

  // 获取询单列表
  getUserInquiryList: '/usb/uwb-app/api/v1/source/queryUserInquiries',

  // 询单详情
  getInquiryDetail: '/usb/uwb-app/api/v1/source/getInquiryDetails',

  // 删除询单
  delInquiry: '/usb/uwb-app/api/v1/source/delInquiry',

  // 商品理解
  getGoodsUnderstand: '/usb/uwb-app/api/v1/search/productUnderstanding',
  // 搜索导航
  keywordSNSearch: '/usb/uwb-app/api/v1/search/keywordSNSearch',

  // 修改询单信息
  updateInquiry: '/usb/uwb-app/api/v1/source/updateInquiry',
};

export default consultOrderMap;
